<div class="gd-outer">

    <!-- Top bar -->
    <div class="gd-topbar">
      <button mat-icon-button class="gd-back-btn" (click)="back()" aria-label="Back">
        <mat-icon>arrow_back_ios_new</mat-icon>
      </button>
      <span class="gd-topbar-title">{{ 'GAMES.GAMEDETAILS' | translate }}</span>
    </div>

    @if (isBusy || isLoading) {
      <mat-progress-bar mode="indeterminate" class="gd-progress"></mat-progress-bar>
    }

    @if (_gameData) {
    <!-- Main scrollable area -->
    <div class="gd-body">

      <!-- Game header hero -->
      <div class="gd-header-wrap">
        <app-game-header-slim [GameDetails]="this._gameData" [Division]="this._gameData.Division" [collapsed]="headerCollapsed()" (collapsedToggle)="toggleHeaderCollapsed()" (onStatisticsUpdated)="getGameData(this._gameId)" (onGradesUpdated)="getReports(this._gameId)"></app-game-header-slim>
       <!--  <app-game-header-full [GameDetails]="this._gameData" [Division]="this._gameData.Division"></app-game-header-full> -->
      </div>

      <!-- Tabs -->
      <mat-tab-group class="gd-tabs" mat-stretch-tabs="false" mat-align-tabs="start">

        <mat-tab label="{{ 'GAMES.HOME' | translate | uppercase }}">
          <app-team-roster
            [Roster]="this._gameData.HomeTeam.Players"
            [TeamIcon]="this._gameData.Game.HomeTeamSmallIcon"
            [GameId]="this._gameId">
          </app-team-roster>
        </mat-tab>

        <mat-tab label="{{ 'GAMES.AWAY' | translate | uppercase }}">
          <app-team-roster
            [Roster]="this._gameData.AwayTeam.Players"
            [TeamIcon]="this._gameData.Game.AwayTeamSmallIcon"
            [GameId]="this._gameId">
          </app-team-roster>
        </mat-tab>

        @if (this._gameData.HomeTeam.LineUpInfo.length > 0) {
          <mat-tab label="{{ 'GAMES.LINEUP' | translate | uppercase }}">
            <div class="gd-lineup-wrap">
              <app-game-lineup
                [LineUpInfo]="this._gameData.HomeTeam.LineUpInfo"
                [TeamIcon]="this._gameData.Game.HomeTeamSmallIcon">
              </app-game-lineup>
              <app-game-lineup
                [LineUpInfo]="this._gameData.AwayTeam.LineUpInfo"
                [TeamIcon]="this._gameData.Game.AwayTeamSmallIcon">
              </app-game-lineup>
            </div>
          </mat-tab>
        }

      <!--   @if (this._gameData.AwayStatistics.length > 0) {
          <mat-tab label="STATISTICS">
            <div class="gd-tab-content">
              <button mat-stroked-button color="primary">
                <mat-icon>add</mat-icon>
                IMPORT FROM SWEHOCKEY
              </button>
            </div>
          </mat-tab>
        } -->

        <mat-tab>
          <ng-template mat-tab-label>
            <span
              [matBadge]="this._flowitems.length"
              [matBadgeHidden]="this._flowitems.length == 0"
              matBadgeOverlap="false">
              {{ 'REPORTS.REPORTS' | translate | uppercase }}
            </span>
          </ng-template>
          <div class="gd-tab-content">
            @if (this._flowitems != null && this._flowitems.length == 0) {
              <div class="gd-empty-msg">NO ITEMS FOUND</div>
            }
            @for (item of this._flowitems; track item.ReportId) {
              @if (item.FlowItemType == 'SCREPORT') {
                <app-report-card [Report]="item" class="gd-flow-card"></app-report-card>
                <mat-divider></mat-divider>
              }
              @if (item.FlowItemType == 'PLAYERNOTE') {
                <app-note-card [Note]="item" class="gd-flow-card"></app-note-card>
                <mat-divider></mat-divider>
              }
            }
          </div>
        </mat-tab>
<!-- 
        <mat-tab label="SCOUTS">
          <div class="gd-tab-content">
            @if (scoutsForGame.length === 0) {
              <div class="gd-empty-msg">NO SCOUTS ADDED THIS GAME TO CALENDAR</div>
            }
            @for (scout of scoutsForGame; track scout.userId) {
              <div class="gd-scout-row">
                <div class="gd-scout-name">{{ scout.displayName }}</div>
                <div class="gd-scout-comment">
                  {{ scout.comment || 'No comment' }}
                </div>
              </div>
              <mat-divider></mat-divider>
            }
          </div>
        </mat-tab> -->

      </mat-tab-group>
    </div>
    } @else if (!isLoading) {
    <div class="gd-body">
      @if (loadError) {
        <div class="gd-empty-msg">{{ loadError }}</div>
      } @else {
        <div class="gd-empty-msg">NO GAME DATA FOUND</div>
      }
    </div>
  }
  </div>

